import { render, staticRenderFns } from "./GroupTagging.vue?vue&type=template&id=68f45085&scoped=true"
import script from "./GroupTagging.vue?vue&type=script&lang=js"
export * from "./GroupTagging.vue?vue&type=script&lang=js"
import style0 from "./GroupTagging.vue?vue&type=style&index=0&id=68f45085&prod&scoped=true&lang=css"
import style1 from "./GroupTagging.vue?vue&type=style&index=1&id=68f45085&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f45085",
  null
  
)

export default component.exports